import * as React from 'react';
import { Header } from './Header';
import { Body } from './Body';
import { Column, SortDirection, DataTableData } from '../DataTable';

export interface TableProps<T extends DataTableData> {
    /**
     * The columns displayed
     */
    columns: Column[];
    /**
     * The column being sorted on
     */
    sortColumn?: Column;
    /**
     * The direction we're sorting
     */
    sortDirection: SortDirection;
    /**
     * Function to handle sorting
     */
    onSort?: (sortColumn: Column, sortDirection: SortDirection) => void;
    /**
     * The items being displayed
     */
    items: T[];
    /**
     * Function to handle an input changing
     */
    onInputChange?: (itemKey: string, column: Column, value: string) => void;
    /**
     * Function to show the fill popup
     */
    showFillPopup: (
        column: Column,
        event: React.MouseEvent<HTMLAnchorElement>
    ) => void;
}

/**
 * The Table Component
 * @param props Component Props
 */
export function Table<T extends DataTableData>(props: TableProps<T>) {
    return (
        <div className="simple-data-table-wrapper">
            <table className="simple-data-table">
                <Header
                    columns={props.columns}
                    sortColumn={props.sortColumn}
                    onSort={props.onSort}
                    sortDirection={props.sortDirection}
                    showFillPopup={(column, event) =>
                        props.showFillPopup(column, event)
                    }
                />
                <Body
                    items={props.items}
                    columns={props.columns}
                    onInputChange={(
                        item: string,
                        column: Column,
                        value: string
                    ) => {
                        if (props.onInputChange) {
                            props.onInputChange(item, column, value);
                        }
                    }}
                />
            </table>
        </div>
    );
}
